import { useState, useEffect, useRef, useCallback } from "react";

import { useNavigate } from "react-router-dom";
import api from "@helpers/api";

import { useCommunity } from "@contexts/CommunityContext";

import CustomModal from "@components/CustomModal";
import ImageImportTool from "@components/ImageImportTool";
import AvailabilityInPlan from "@components/AvailabilityInPlan";

import { Input, Text, Button } from "@fragments";

import { ReactComponent as CoinIcon } from "@assets/draws/coin.svg";

import * as Material from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import './styles.scss'

import {
  AddLinkRounded,
  DirectionsRunRounded,
  EditRounded,
  EmojiEventsRounded,
  FavoriteRounded,
  HubRounded,
  SellRounded,
  SendTimeExtensionRounded,
  SlowMotionVideoRounded,
  SportsEsportsRounded,
  TuneRounded,
  WidgetsRounded,
} from "@mui/icons-material";

import LinkIcon from "@mui/icons-material/Link";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { ShutterSpeedRounded } from "@material-ui/icons";

const Coin = () => <CoinIcon width={14} height={14} />;

export default function ConfigGroupModal({ modalRef }) {
  const REF_config = useRef({});
  const REF_community = useRef({});
  const REF_callback = useRef();

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState(REF_config.current.type);

  const { loadCommunities, community } = useCommunity();

  const nav = useNavigate();

  modalRef.current = {
    open(preFill, callback) {
      if (!preFill.group?.id) {
        REF_config.current = { ...community.group.pattern };
      } else {
        REF_config.current = { ...preFill.group };
      }
      REF_community.current = { ...preFill.community };
      REF_callback.current = callback;
      console.log(preFill);
      setType(REF_config.current.type);
      setOpen(true);
    },
  };

  async function handleSubmit() {
    try {
      const payload = getPayload();

      console.log(payload);

      setLoading(true);

      const { data } = await api.post("community/group", payload);

      if (data.id) {
        await REF_callback.current(data);
        setOpen(false);
      }
    } catch (e) {
      console.log(e);
    }

    setLoading(false);

    function getPayload() {
      const {
        id,
        name,
        description,
        banner_base64,
        availability,
        type,
        awards,
        gamification,
        interactions_enabled,
        links,
        interval,
      } = REF_config.current;

      const data = {
        community_id: parseInt(REF_community.current.id),
        name: name.trim(),
        description: description?.trim(),
        availability,
        type,
        awards,
        gamification,
        interactions_enabled,
        links,
        interval,
      };

      if (!!id) {
        data.id = parseInt(id);
      }
      if (!!banner_base64 && !banner_base64?.startsWith("http")) {
        data.banner_base64 = banner_base64;
      }

      return data;
    }
  }

  async function handleDelete() {
    try {
      const { data } = await api.delete("group?id=" + REF_config.current.id);
    } catch (e) {
      console.log(e);
    }

    nav(-1);

    loadCommunities();

    setOpen(false);
  }

  const handleAvailabilityChange = useCallback((result) => {
    REF_config.current.availability = result ? [...result] : [];
  }, []);

  function General() {
    return (
      <>
        <div className="banner-add mt-2">
          <ImageImportTool
            displayTitle={false}  
            aspectRatio={1}
            size={92}
            imageMaxWidth={720}
            src={REF_config.current.banner_base64 || REF_config.current.banner}
            onCrop={(imageBase64) => {
              REF_config.current.banner_base64 = imageBase64;
            }}
            title="Redimensionar banner da comunidade"
          />
        </div>

        <Text.h3 left={<TuneRounded />} value="Configurações gerais" className="mt-2 mb-1" />

        <Input.Text
          placeholder="Nome do grupo"
          value={REF_config.current.name}
          onInput={(v) => {
            REF_config.current.name = v;
          }}
          label="Insira o nome do grupo"
          size={25}
        />
        <Input.Text
          className="mt-2"
          placeholder="Descrição (opcional)"
          value={REF_config.current.description}
          onInput={(v) => {
            REF_config.current.description = v;
          }}
          emoji
          multiline
          label="Adicione uma descrição detalhada ao grupo"
          size={250}
        />
      </>
    );
  }
  function DescriptionLinks() {
    const [links, setLinks] = useState(REF_config.current.links || []);

    const LinkInfo = ({ data, index }) => {
      const [open, setOpen] = useState(!!data.open);
      const [title, setTitle] = useState(data.title);
      const [link, setLink] = useState(data.url);

      useEffect(() => {
        REF_config.current.links[index].open = open;
      }, [open]);

      if (!open)
        return (
          <div className="description-link-row bsf-9">
            <div className="description-link">
              <LinkIcon className="url-icon" />
              <h5 className="title">{title || <i>(Não configurado)</i>}</h5>
              <span className="url">{link}</span>
              <Button
                size="small"
                color="overlay"
                className="edit-link-btn"
                onClick={() => setOpen(true)}
                icon={<EditRounded />}
              />
            </div>
          </div>
        );

      return (
        <div className="link-info-block mt-2 px-2 py-1">
          <Input.Text
            autoFocus
            value={title}
            onInput={(e) => {
              const linkCopy = [...links];
              linkCopy[index].title = e;
              REF_config.current.links = [...linkCopy];
              setTitle(e);
            }}
            label="Título do link"
            size={25}
            placeholder="O título do link será o texto do botão no app"
          />
          <Input.Text
            className={"mt-1"}
            value={link}
            onInput={(value) => {
              const linkCopy = [...links];
              linkCopy[index].url = value;
              REF_config.current.links = [...linkCopy];
              setLink(value);
            }}
            start="https://"
            color="primary"
            label="Link"
            size={150}
            placeholder="Insira o link do link"
          />
          <div className="mt-1 link-buttons-footer">
            <Button
              size="small"
              color="error"
              onClick={() => {
                const linkCopy = [...links];
                linkCopy.splice(index, 1);
                REF_config.current.links = [...linkCopy];
                setLinks([...linkCopy]);
              }}
              endIcon={<DeleteIcon color="error" />}
              text="Remover"
            />
            <Button
              size="small"
              variant="inverse"
              onClick={() => {
                setOpen(false);
              }}
              endIcon={<CheckRoundedIcon color="primary" />}
              text="Concluir edição"
            />
          </div>
        </div>
      );
    };

    const linksElm =
      links?.length > 0 ? (
        <>
          {links?.map((linkInfo, i) => (
            <LinkInfo data={linkInfo} key={i} index={i} />
          ))}
        </>
      ) : null;

    return (
      <div className="pb-2">
        <Text.h3
          left={<AddLinkRounded />}
          value="Links na descrição"
          className="mt-5 mb-2"
          grow
          right={
            <Button
              color="overlay"
              variant="dashed"
              onClick={() => {
                const linksCopy = [...links];
                linksCopy.push({ title: "", url: "", open: true });
                REF_config.current.links = [...linksCopy];
                setLinks([...linksCopy]);
              }}
              size="small"
              disabled={links?.length >= 3}
              endIcon={<AddIcon />}
              text="Adicionar link"
            />
          }
        />
        {linksElm}
      </div>
    );
  }
  function Interactions() {
    const [interactionsEnabled, setInteractionsEnabled] = useState(
      REF_config.current?.interactions_enabled
    );

    return (
      <>
        <Text.h3
          value="Publicações no grupo"
          className="mt-5 mb-1"
          grow
          left={<SendTimeExtensionRounded />}
        />

        <Text.h5
          grow
          contrast={5}
          value="Caso as interações estejam desabilitadas, membros não administradores não poderao publicar no grupo"
        />

        <Input.Switch
          value={interactionsEnabled}
          onInput={(e) => {
            REF_config.current.interactions_enabled = e;
            setInteractionsEnabled(e);
          }}
          label="Permitir publicações"
        />
      </>
    );
  }
  function Type() {
    useEffect(() => {
      REF_config.current.type = type;
    }, [type]);

    const ListOption = ({ value, label, subtitle }) => {
      return (
        <span
          className={"radio-option " + (type === value ? "radio-checked" : "")}
        >
          <Material.FormControlLabel
            className="radio-option-label"
            value={value}
            label={
              <div className="py-1 pr-1">
                <span>
                  <b>{label}</b>:{" "}
                </span>
                <small>{subtitle}</small>
              </div>
            }
            control={
              <Material.Radio color="secondary" checked={type === value} />
            }
          />
        </span>
      );
    };

    return (
      <>
        <Text.h3
          value="Tipo de grupo"
          className="mt-5 mb-1"
          grow
          left={<WidgetsRounded />}
        />

        <Input.Choices
          onInput={setType}
          value={type}
          options={[
            {
              "value": "CHALLENGE",
              "label": "Desafio",
              "description": "Crie um desafio com data de início e data de fim. Neste modo você pode rankear interações no grupo."
            },
            {
              "value": "LIFETIME",
              "label": "Lifetime",
              "description": "Neste modo as interações não serão gamificadas, e o grupo não terá uma data de início / fim."
            }
          ]}
        />
      </>
    );
  }
  function Expiration() {
    const [duration, setDuration] = useState(getInitialDuration());
    const [startAt, setStartAt] = useState(
      dayjs(REF_config.current.interval.start_date)
    );

    useEffect(() => {
      updateEndDate();
    }, [duration]);
    useEffect(() => {
      REF_config.current.interval.start_date =
        dayjs(startAt).format("YYYY-MM-DD");
      updateEndDate();
    }, [startAt]);

    function updateEndDate() {
      const newDate = dayjs(REF_config.current.interval.start_date)
        .add(duration, "day")
        .format("YYYY-MM-DD");
      REF_config.current.interval.end_date = newDate;
    }
    function getInitialDuration() {
      if (!REF_config.current.interval.end_date) return 21;

      const end = dayjs(REF_config.current.interval.end_date).diff(
        dayjs(REF_config.current.interval.start_date),
        "day"
      );

      return end;
    }

    const durationChildren =
      type === "CHALLENGE" ? (
        <>
          <Material.Stack
            spacing={1}
            direction="row"
            alignItems="center"
            className="px-2 mb-1 mt-2"
          >
            <Material.Slider
              color="primary"
              aria-label="Volume"
              value={duration}
              onChange={(v) => {
                setDuration(v.target.value);
              }}
              min={7}
              max={120}
            />

            <Material.Typography
              variant="h5"
              style={{
                textWrap: "nowrap",
              }}
            >
              {duration} dias
            </Material.Typography>
          </Material.Stack>
          <div className="durations-row">
            <Button
              size='small'
              onClick={() => setDuration(7)}
              text="7 dias"
              color={duration === 7 ? "primary" : "overlay"}
            />
            <Button
              size='small'
              onClick={() => setDuration(15)}
              text="15 dias"
              color={duration === 15 ? "primary" : "overlay"}
            />
            <Button
              size='small'
              onClick={() => setDuration(21)}
              text="21 dias"
              color={duration === 21 ? "primary" : "overlay"}
            />
            <Button
              size='small'
              onClick={() => setDuration(30)}
              text="30 dias"
              color={duration === 30 ? "primary" : "overlay"}
            />
            <Button
              size='small'
              onClick={() => setDuration(60)}
              text="60 dias"
              color={duration === 60 ? "primary" : "overlay"}
            />
          </div>

          <>
            <Text.h3
              className="mt-5"
              value="Data de início"
              grow
              left={<SlowMotionVideoRounded />}
            />

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateCalendar
                size="small"
                value={startAt}
                onChange={(v) => setStartAt(v)}
                id="calendar"
                color="primary"
                showDaysOutsideCurrentMonth
                className="challenge-calendar"
              />
            </LocalizationProvider>
          </>
        </>
      ) : null;

    return (
      <>
        <Text.h3
          className="mt-4"
          value="Duração do desafio"
          grow
          left={<ShutterSpeedRounded />}
        />
        {durationChildren}
      </>
    );
  }
  function Awards() {
    const [awards, setAwards] = useState(REF_config.current.awards);

    useEffect(() => {
      REF_config.current.awards = [...awards];
    }, [awards]);

    function handleTitleInput(value, i) {
      const awardsCopy = [...awards];
      awardsCopy[i].title = value;
      setAwards([...awardsCopy]);
    }
    function handleAddBanner(image, i) {
      const awardsCopy = [...awards];
      awardsCopy[i].banner = image;
      setAwards([...awardsCopy]);
    }
    function handleRemove(i) {
      const awardsCopy = [...awards];
      awardsCopy.splice(i, 1);
      setAwards([...awardsCopy]);
    }
    function handleAddAward() {
      const awardsCopy = [...awards];
      awardsCopy.push({
        banner: "",
        title: "",
      });
      setAwards([...awardsCopy]);
    }

    const awardsChildren =
      awards?.length > 0 && type === "CHALLENGE" ? (
        <>
          {awards.map((award, i) => {
            return (
              <div className="award-row mt-2" key={i}>
                <ImageImportTool
                  size={40}
                  key={Math.random()}
                  src={award.banner}
                  onLoaded={(imageBase64) => handleAddBanner(imageBase64, i)}
                  title="Redimensionar foto do prêmio"
                  displayTitle={false}
                />
                <Input
                  placeholder="Título da premiação"
                  className={"counter-input fade delay-1"}
                  value={award.title || ""}
                  onInput={(e) => handleTitleInput(e.target.value, i)}
                  color="primary"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />
                <Button
                  size="small"
                  onClick={() => handleRemove(i)}
                  icon={<DeleteIcon />}
                  color="overlay"
                />
              </div>
            );
          })}
        </>
      ) : null;

    return (
      <>
        <Text.h3
          value="Premiações"
          className="mt-3"
          grow
          left={<EmojiEventsRounded />}
          right={
            type === "CHALLENGE" && (
              <Button
                size="small"
                color="overlay"
                onClick={handleAddAward}
                icon={<AddIcon />}
                tooltip="Adicionar prêmio"
              />
            )
          }
        />
        {awardsChildren}
      </>
    );
  }
  function GamificationSettings() {
    const settings = REF_config.current.gamification;

    function updatePostSettings(mode, config, value) {
      const copy = { ...settings };
      copy.posts[mode][config] = value;
      REF_config.current.gamification = { ...copy };
    }

    function updateInteractionsSettings(config, value) {
      const copy = { ...settings };
      copy.interactions[config] = value;
      REF_config.current.gamification = { ...copy };
    }

    function updateActivitySettings(config, value) {
      const copy = { ...settings };
      copy.activity[config] = value;
      REF_config.current.gamification = { ...copy };
    }

    function Cell({ value, onChange, hasCoin = false }) {
      const [v, setV] = useState(value);
      return (
        <Material.TableCell align="center" sx={{ padding: "4px" }}>
          <Input.Integer
            start={hasCoin && <Coin style={{ width: '20px', height: '20px' }} />}
            value={v}
            onInput={(e) => {
              const newValue = e.target.value;
              setV(newValue);
              onChange(newValue);
            }}
            className="custom-gamification-input"
            onChange={(e) => {
              const numericString = e.target.value.replace(/\D/g, "");
              const parsed = parseInt(numericString, 10) || 0;
              setV(parsed);
              onChange(parsed);
            }}
          />
        </Material.TableCell>
      );
    }

    const gamificationChildren =
      type === "CHALLENGE" ? (
        <div>
          <Material.TableContainer className="gamification-table">
            <Material.Table aria-label="simple Material.table">
              <Material.TableHead>
                <Material.TableRow>
                  <Material.TableCell
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      width: "164px",
                    }}
                  >
                    <HubRounded
                      fontSize="small"
                      style={{ transform: "translateY(-3px)" }}
                    />
                    <span className="title">Posts</span>
                  </Material.TableCell>
                  <Material.TableCell align="center" className="title">
                    Pontos
                  </Material.TableCell>
                  <Material.TableCell align="center" className="title">
                    Limite diário
                  </Material.TableCell>
                </Material.TableRow>
              </Material.TableHead>
              <Material.TableBody>
                <Material.TableRow>
                  <Material.TableCell style={{ width: "164px" }}>
                    Com foto
                  </Material.TableCell>
                  <Cell
                    value={settings.posts.with_photo.points}
                    onChange={(v) =>
                      updatePostSettings("with_photo", "points", v)
                    }
                    hasCoin={true}
                  />
                  <Cell
                    value={settings.posts.with_photo.daily_limit}
                    onChange={(v) =>
                      updatePostSettings("with_photo", "daily_limit", v)
                    }
                  />
                </Material.TableRow>
                <Material.TableRow>
                  <Material.TableCell style={{ width: "164px" }}>
                    Apenas texto
                  </Material.TableCell>
                  <Cell
                    value={settings.posts.only_text.points}
                    onChange={(v) =>
                      updatePostSettings("only_text", "points", v)
                    }
                    hasCoin={true}
                  />
                  <Cell
                    value={settings.posts.only_text.daily_limit}
                    onChange={(v) =>
                      updatePostSettings("only_text", "daily_limit", v)
                    }
                  />
                </Material.TableRow>

                <br /><br />
                <Material.TableRow>
                  <Material.TableCell
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      width: "164px",
                    }}
                  >
                    <FavoriteRounded
                      fontSize="small"
                      style={{ transform: "translateY(-2px)" }}
                    />
                    <span className="title">Interações</span>
                  </Material.TableCell>
                  <Material.TableCell align="center" className="title">
                    Pontos
                  </Material.TableCell>
                  <Material.TableCell align="center" className="title">
                    Limite diário
                  </Material.TableCell>
                </Material.TableRow>
                <Material.TableRow>
                  <Material.TableCell
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      width: "164px",
                    }}
                  >
                    Reações
                  </Material.TableCell>
                  <Cell
                    hasCoin={true}
                    value={settings.interactions.like}
                    onChange={(v) => updateInteractionsSettings("like", v)}
                  />
                  <Material.TableCell align="center">-</Material.TableCell>
                </Material.TableRow>
                <Material.TableRow>
                  <Material.TableCell
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      width: "164px",
                    }}
                  >
                    Comentários
                  </Material.TableCell>
                  <Cell
                    hasCoin={true}
                    value={settings.interactions.comment}
                    onChange={(v) => updateInteractionsSettings("comment", v)}
                  />
                  <Material.TableCell align="center">-</Material.TableCell>
                </Material.TableRow>


                <br /><br />
                <Material.TableRow>
                  <Material.TableCell
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      width: "164px",
                    }}
                  >
                    <DirectionsRunRounded
                      fontSize="small"
                      style={{ transform: "translateY(-2px)" }}
                    />
                    <span className="title">Atividades</span>
                  </Material.TableCell>
                  <Material.TableCell align="center" className="title">
                    Pontos
                  </Material.TableCell>
                  <Material.TableCell align="center" className="title">
                    Limite diário
                  </Material.TableCell>
                </Material.TableRow>
                <Material.TableRow>
                  <Material.TableCell
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      width: "164px",
                    }}
                  >
                    Registro
                  </Material.TableCell>
                  <Cell
                    hasCoin={true}
                    value={settings.activity.points}
                    onChange={(v) => updateActivitySettings("points", v)}
                  />
                  <Cell
                    value={settings.activity.daily_limit}
                    onChange={(v) => updateActivitySettings("daily_limit", v)}
                  />
                </Material.TableRow>
              </Material.TableBody>
            </Material.Table>
          </Material.TableContainer>
        </div>
      ) : null;

    return (
      <>
        <Text.h3 className="mb-2 mt-4"
          value="Regras de pontuação"
          left={<SportsEsportsRounded />}
        />

        {gamificationChildren}
      </>
    );
  }

  return (
    <CustomModal
      maxWidth={530}
      bottomButtonSumbitText="Salvar grupo"
      bottomButtonCancelText="Cancelar"
      loading={loading}
      handleDelete={REF_config.current?.id && handleDelete}
      deletionTitle="Você realmente deseja apagar este grupo permanentemente?"
      title={REF_config.current?.id ? "Editar grupo" : "Criar novo grupo"}
      handleSubmit={handleSubmit}
      open={open}
      className="config-group-modal"
      handleClose={() => setOpen(false)}
      bodyComponent={
        open ? (
          <div className="px-4 py-1">
            <General />

            <DescriptionLinks />

            <Text.h3
              className="mt-4 mb-2"
              left={<SellRounded />}
              value="Grupo disponível nos planos"
            />

            <AvailabilityInPlan
              community={REF_community.current?.id}
              initialValues={REF_config.current?.availability}
              onChange={handleAvailabilityChange}
              className="mt-1"
            />

            <Interactions />

            <Type />

            {type === "CHALLENGE" && (
              <>
                <Expiration />
                <Awards />
                <GamificationSettings />
              </>
            )}
          </div>
        ) : null
      }
    />
  );
}
